import { DocType } from '../global/Doc.enum';
import Root from '../Root';
import { IconType } from '../global/Icon.enum';
import { ColorType } from '../global/Color.enum';
import { FieldType, FieldEntity } from './Field.enum';
import type { IField } from './Field.interface';

export default class Field extends Root implements IField {
  name: string;
  description: string;
  color: ColorType;
  icon: IconType;
  type: FieldType;
  options: any;
  value: any;
  entity: FieldEntity;

  getName() {
    return this.name;
  }

  getDescription() {
    return this.description;
  }

  getType() {
    return this.type.title();
  }

  hasOptions() {
    return (
      this.type.name === FieldType.options_multiple.name ||
      this.type.name === FieldType.options_single.name
    );
  }

  fieldOptions() {
    const options = this.options.replace(/\n+/g, '\n');
    return this.hasOptions ? options.split('\n') : [];
  }

  static build = (data: IField) => new Field(data);
  static blank = (type) => new Field({ type, isActive: true });

  /**
   * Constructor
   * @param {IField} data
   */
  constructor(data?: IField) {
    super(DocType.of('__definition.field'), data);

    this.name = data?.name || '';
    this.description = data?.description || '';
    // TODO: data?.color?.id is legacy data structure
    this.color = ColorType.of(
      data?.color?.name
        ? data?.color?.name
        : `${data?.color?.id}_${data?.color?.variation || '500'}`
    );
    // TODO: data?.icon?.id is legacy data structure
    this.icon = IconType.of(data?.icon?.name || data?.icon?.id);
    this.type = FieldType.of(data?.type?.name || data?.type);
    this.options = data?.options || '';
    this.value = data?.value || '';
    // TODO: data?.fieldType is legacy data structure
    this.entity = FieldEntity.of(data?.entity?.name || data?.fieldType);
  }
}
